export enum PaymentBrand {
  NONE = "NONE",
  MADA = "MADA",
  VISA = "VISA",
  APPLEPAY = "APPLEPAY",
}
export interface ICheckoutRequest {
  paymentBrand: PaymentBrand;
  contractId: string;
  amount: number;
  currency?: string | null;
  customerType: string;
  paymentType: string;
  beneficiaryId: string;
  beneficiaryName: string;
  otherUserId: string | number;
  otherUserName: string;
  fees: number;
  shortContractId: string;
  customer: {
    email: string;
    givenName?: string;
    surname: string;
  };
}

export type status = "SUCCESS" | "FAILED" | "PENDING";
export interface ICheckoutResponse {
  data: {
    httpStatus: string;
    id: string;
    paymentBrand: string;
    result: { code: string; description: string };
    status: status;
  };
  status: number;
  successful: boolean;
  timestamp: Date;
}
